import { Link } from 'react-router-dom';
import './ChevronLink.css';
import { ReactNode } from 'react';

type Props = {
    chevronDirection: 'left' | 'right' | 'up' | 'down' | 'left-down' | 'left-up';
    text?: string;
    children?: ReactNode;
    linkUrl?: string;
    linkDisabled?: boolean;
    onClick?: () => void;
    className?: string;
};

const ChevronLink = ({
    chevronDirection,
    text,
    children,
    linkUrl,
    linkDisabled = false,
    onClick,
    className
}: Props) => {
    const isHorizontalDirection = chevronDirection === 'left' || chevronDirection === 'right';
    const isExternalLink = linkUrl?.startsWith('http') || linkUrl?.startsWith('mailto') || linkUrl?.startsWith('tel');
    const wrapperClassName = `chevronLink chevronLink-${chevronDirection} ${className || ''}`;
    const content = (
        <>
            {text || children}
            <span className='material-symbols-rounded'>
                {isHorizontalDirection ? 'chevron_right' : 'keyboard_arrow_up'}
            </span>
        </>
    );

    if (linkDisabled) {
        return (
            <div className={wrapperClassName} onClick={onClick}>
                {content}
            </div>
        );
    }

    if (isExternalLink) {
        return (
            <a href={linkUrl} className={wrapperClassName} onClick={onClick} target='_blank'>
                {content}
            </a>
        );
    }

    return (
        <Link to={linkUrl ?? ''} className={wrapperClassName} onClick={onClick}>
            {content}
        </Link>
    );
};

export default ChevronLink;
